import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 9D29290D-A243-4C72-BC8C-ABCDFB4448B2
 * name flip-horizontal
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/flip-horizontal.svg
 * tags
 * - Arrange 
 */
export const FlipHorizontalIcon = createSvgIcon(<><path d="M15 21H17V19H15M19 9H21V7H19M3 5V19C3 20.1 3.9 21 5 21H9V19H5V5H9V3H5C3.9 3 3 3.9 3 5M19 3V5H21C21 3.9 20.1 3 19 3M11 23H13V1H11M19 17H21V15H19M15 5H17V3H15M19 13H21V11H19M19 21C20.1 21 21 20.1 21 19H19Z" /></>, 'FlipHorizontalIcon');
export default FlipHorizontalIcon